import {
  createRoiEndPoint,
  updateRoiEndPoint,
  deleteRoiEndPoint,
  listRoiEndPoint,
  addTagToDeviceEndPoint,
  fetchRulesByDeviceIdEndPoint,
  DeployRoiEndPoint,
  UpdateDeployRoiEndPoint,
  fetchROILocationsByCVAppEndPoint,
  getCameraCalibrateEndPoint,
  bulkUnsubscribeCVApps
} from "../configuration";
import axiosInstance from "../global/axiosInterceptor";

export const createRoi = async (payload, activeSession) => {
  try {
    const roiRespose = await axiosInstance.post(createRoiEndPoint(), payload);
    const res = roiRespose.data;
    return res;
  } catch (e) {
    //console.log(e);
    return { status: 500, error: e };
  }
};

export const deployRoi = async (payload, activeSession) => {
  try {
    const roiRespose = await axiosInstance.post(DeployRoiEndPoint(), payload);
    const res = roiRespose.data;
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const updateDeployRoi = async (payload, activeSession) => {
  try {
    const roiRespose = await axiosInstance.post(UpdateDeployRoiEndPoint(), payload);
    const res = roiRespose.data;
    return res;
  } catch (e) {
    console.log(e);
    throw new Error(e.response);
  }
};

export const updateRoi = async (payload, activeSession) => {
  try {
    const roiRespose = await axiosInstance.put(updateRoiEndPoint(), payload);
    const res = roiRespose.data;
    return res;
  } catch (e) {
    console.log(e);
    return { status: 500, error: e };
  }
};

export const fetchRoiWithCvApps = async (accountId) => {
  const payload = {
    accountname: accountId,
    filter: {
      $expand: "fields,cvapp,deploy",
      $selection: { kind: "ts.device.onvif.roi" }
    }
  };
  try {
    const roiRespose = await axiosInstance.post(listRoiEndPoint(), payload);
    const res = roiRespose.data;
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const deleteRoi = async (payload, activeSession) => {
  try {
    const roiRespose = await axiosInstance.delete(deleteRoiEndPoint(), {
      data: payload
    });
    const res = roiRespose.data;
    return res;
  } catch (e) {
    console.log(e);
    throw e; // Re-throw so saga can catch it
  }
};

export const listRoi = async (payload, activeSession) => {
  try {
    const roiRespose = await axiosInstance.post(listRoiEndPoint(), payload);
    const res = roiRespose.data;
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const addTagsStatistic = async (roiId, tagIds, siteId, selectedTagIds, activeSession) => {
  if (!activeSession?.accountId) {
    throw new Error('Invalid session');
  }
  try {
    const tagsWithoutSiteId = Array.isArray(tagIds) ? tagIds.filter(tagId => tagId !== siteId) : [];
    const response = await axiosInstance.patch(addTagToDeviceEndPoint(), {
      accountname: activeSession?.accountId,
      resourceidentifier: {
        deviceid: roiId
      },
      device: {
        tagids: tagIds,
        customdata: {
        statisticstagids: (selectedTagIds && Array.isArray(selectedTagIds) && selectedTagIds.length > 0) ? selectedTagIds : tagsWithoutSiteId
        }
      }
    });
    const res = response.data;
    return res;
  } catch (error) {
    console.error("Error creating resource:", error);
    return null;
  }
};

export const getRulesByDeviceId = async (payload) => {
  if (!payload) {
    // Optionally log or handle the missing payload case
    return null;
  }
  try {
    const rulesResponse = await axiosInstance.post(fetchRulesByDeviceIdEndPoint(), payload);
    const res = rulesResponse.data;
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const getRoiLocationsByAppId = async (appId, activeSession) => {
  try {
    const rulesResponse = await axiosInstance.post(fetchROILocationsByCVAppEndPoint(), {
      accountname: activeSession.accountId,
      resourceidentifier: {
        id: appId
      }
    });
    const res = rulesResponse.data;
    return res;
  } catch (e) {
    console.log(e);
  }
};

export const setCameraCaliration = async (payload, activeSession) => {
  try {
    const calibrationResponse = await axiosInstance.post(getCameraCalibrateEndPoint(), payload);
    const status = calibrationResponse.status;
    return status;
  } catch (e) {
    console.log(e);
    return e.response;
  }
};

export const cvAppBulkUndeployApi = async (cvappids, fovid, activeSession) => {
  try {
    const undeployResponse = await axiosInstance.post(bulkUnsubscribeCVApps(), {
      accountname: activeSession.accountId,
      resourceidentifiers: [
        {
          cvappids: cvappids,
          fovid: fovid
        }
      ]
    });
    const status = undeployResponse.status;
    return status;
  } catch (e) {
    console.log(e);
    return e.response;
  }
};
